import { FunctionComponent } from 'react';

import Icon from '../Icon';
import { IconPropsInterface } from '../Icon.types';

const MenuDotsVerticalIcon: FunctionComponent<IconPropsInterface> = ({
  color = 'black',
  size = '24px',
  ...rest
}) => (
  <Icon size={size} color={color} {...rest}>
    <path d="M0 0h24v24H0z" fill="none" />
    <path
      d="M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
      fill="currentColor"
    />
  </Icon>
);

MenuDotsVerticalIcon.displayName = 'MenuDotsVerticalIcon';

export default MenuDotsVerticalIcon;
